import type { Breadcrumb } from '@eliadmin/core/src/api/products/types/product-types';
import type { Category } from '@eliadmin/core/src/api/slugs/types/slug-detail-types';
import { ROUTES } from '@eliadmin/core/src/constants/routes';

type CategoryTrail = Category['breadcrumb'] | null;

export function eshopBreadcrumb(child?: Breadcrumb): Breadcrumb {
  return { name: 'E-shop', slug: ROUTES.ESHOP(), child };
}

/** The backend trail is root-first with bare slugs; links must go through the configured route. */
function toCategoryRoutes(node: CategoryTrail | undefined): Breadcrumb | undefined {
  if (!node) return undefined;
  return {
    name: node.name,
    slug: ROUTES.CATEGORY({ slug: node.slug }),
    child: toCategoryRoutes(node.child),
  };
}

/** E-shop › every ancestor › current category. */
export function buildCategoryBreadcrumb(
  category: Pick<Category, 'name' | 'slug' | 'breadcrumb'>,
): Breadcrumb {
  return eshopBreadcrumb(
    toCategoryRoutes(category.breadcrumb) ?? {
      name: category.name,
      slug: ROUTES.CATEGORY({ slug: category.slug }),
    },
  );
}
